export const PROFILE_SCOPE_STORAGE_KEY = "profileScope";
export const PROFILE_SCOPE_OWNER_USER_ID_KEY = "profileScopeOwnerUserId";
export const HYBRID_APP_MODE_STORAGE_KEY = "hybridAppMode";
